import React from 'react';
import { shallow } from 'zustand/shallow';
import { useVoiceConfigurationStore } from '../../zustand-store/useVoiceConfigurationStore';
import { IVoice, VoiceConfigurationOptions } from "../../zustand-store/useAIVoicesStore"
import { isPitchDisabled, isSpeedDisabled, isStyleDisabled } from '../../zustand-store/useVoiceFiltersStore';

export const VolumeSlider = () => {
    
    const { setVoiceConfiguration, voiceConfiguration: {volume} } = useVoiceConfigurationStore((state) => ({
        voiceConfiguration: state.voiceConfiguration,
        setVoiceConfiguration: state.setVoiceConfiguration
    }), shallow)


    return (
        <div className="mb-3">
            <label className="d-inline-flex align-items-center">
                <span>Volume</span>
                <span style={{background : "var(--bs-primary)"}} className="badge text-bg-secondary ms-1">{volume}</span>
            </label>
            <input type="range" className="form-range" min="-6" max="6" step="0.5" defaultValue="0" name="volume" value={volume} onChange={(e) => {
                setVoiceConfiguration(VoiceConfigurationOptions.volume, e.target.valueAsNumber)
            }} />
        </div>
    )
}

interface ISpeedSliderProps {
    voice: IVoice
}

export const SpeedSlider = ({ voice }: ISpeedSliderProps) => {

    const { setVoiceConfiguration, voiceConfiguration: {speed} } = useVoiceConfigurationStore((state) => ({
        voiceConfiguration: state.voiceConfiguration,
        setVoiceConfiguration: state.setVoiceConfiguration
    }), shallow)

    if (voice === null || isSpeedDisabled(voice)) {
        return <></>
    }

    return (
        <div className="mb-3">
            <label className="d-inline-flex align-items-center"><span>Speed</span><span style={{background : "var(--bs-primary)"}} className="badge text-bg-secondary ms-1">{speed}</span></label>
            <input type="range" className="form-range" min="20" max="200" step="1" defaultValue="100" name="speed" onChange={(e) => {
                setVoiceConfiguration(VoiceConfigurationOptions.speed, e.target.valueAsNumber)
            }} />
        </div>
    )
}

interface IPitchDropdownProps {
    voice: IVoice
}

export const PitchDropdown = ({ voice }: IPitchDropdownProps) => {

    const { setVoiceConfiguration, voiceConfiguration: {pitch} } = useVoiceConfigurationStore((state) => ({
        voiceConfiguration: state.voiceConfiguration,
        setVoiceConfiguration: state.setVoiceConfiguration
    }), shallow)

    if (voice === null || isPitchDisabled(voice, voice)) {
        return <></>
    }

    return (
        <div className="mb-3 mt-3">
            <label>Pitch</label>
            <select className="form-select" name="pitch" value={pitch} onChange={(e) => {
                setVoiceConfiguration(VoiceConfigurationOptions.pitch, e.target.value);
            }}>
                <option value="">Default</option>
                <option value="x-low">x-low</option>
                <option value="low">low</option>
                <option value="medium">medium</option>
                <option value="high">high</option>
                <option value="x-high">x-high</option>
            </select>
        </div>
    )
}

interface IStylesDropdownProps {
    voice: IVoice
}

export const StylesDropdown = ({ voice }: IStylesDropdownProps) => {

    const { voiceConfiguration: {style}, setVoiceConfiguration } = useVoiceConfigurationStore((state) => ({
        voiceConfiguration: state.voiceConfiguration,
        setVoiceConfiguration: state.setVoiceConfiguration, 
    }), shallow)

    if (voice === null || isStyleDisabled(voice, voice)) {
        return <></>
    }

    return (
        <div className="mb-3 mt-3">
            <label>Styles</label>
            <select value={style} className="form-select" name="style" onChange={(e) => {
                setVoiceConfiguration(VoiceConfigurationOptions.style, e.target.value)
            }}>
                <option value="">Default</option>
                {
                    voice?.styles.map((style) => {
                        return <option value={style} key={style}>{style}</option>
                    })
                }
            </select>
        </div>
    )
}